//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockBatchGet', {
//        templateUrl: 'views/components/views/stockBatchGet/stockBatchGet.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'stockBatchGetService', function ($stateParams, stateService, translateService, modalService, stockBatchGetService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockBatchKeyno = $stateParams.stockbatch_keyno;
//            let p2ReportDefKeyno = '';

//            let translations = {
//                printdialogue_undefined_report: '',
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                bgBatchDelivery: {
//                    selected: '0',
//                    buttons: [
//                        { id: '0', label: 'batchdelivery_gb_simple', color: 'primary', onClick: () => vm.model.bgBatchDelivery.selected = '0' },
//                        { id: '1', label: 'batchdelivery_gb_details', color: 'primary', onClick: () => vm.model.bgBatchDelivery.selected = '1' },
//                        { id: '2', label: 'batchdelivery_gb_tracing', color: 'primary', onClick: () => vm.model.bgBatchDelivery.selected = '2' }
//                    ]
//                },
//                stockLocationNameButtons: [
//                    { id: 'goto', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => stateService.go('selectstocklocation', { stockplace_id: vm.model.edit.stockplace_id }) }
//                ],
//                productButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_keyno }) }
//                ],
//                allocationInfoButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => goToFunc('allocation_state') }
//                ],
//                purchaseOrderButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('purchhead', { purch_internal_no: vm.model.edit.purch_internal_no }) }
//                ],
//                batchDeliveryButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('batchdelivery', { batchdelivery_keyno: vm.model.edit.batchdelivery_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await stockBatchGetService.getEdit({ stockbatch_keyno: stockBatchKeyno }))[0];
//            }

//            async function retrieveReportDefinitions() {
//                const response = (await stockBatchGetService.getReportDefinition({ report_filename: vm.model.edit.report_name }))[0];

//                p2ReportDefKeyno = response?.p2_reportdef_keyno;
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgBatchDelivery = function (value) {
//                vm.model.bgBatchDelivery.selected = value;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                stockBatchGetService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            function goToFunc(state) {
//                switch (state) {
//                    case 'allocation_state':
//                        if (vm.model.edit.allocation_state === '' || vm.model.edit.allocation_parms === '') {
//                            modalService.confirm({
//                                type: 'warning',
//                                title: translations.confirm_title,
//                                message: 'Ingen allokering',
//                                okLabel: translations.confirm_ok_label,
//                                cancelLabel: translations.confirm_cancel_label
//                            }).then(function () {
//                                return;
//                            });
//                        } else {
//                            stateService.go(vm.model.edit.allocation_state, vm.model.edit.allocation_parms);
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'printdialogue':
//                        if (p2ReportDefKeyno > '') {
//                            go({
//                                webpage_name: stateService.getCurrentName(),
//                                argtype: 'stockbatch_keyno',
//                                argvalue: vm.model.edit.stockbatch_keyno,
//                                p2_reportdef_keyno: p2ReportDefKeyno
//                            });
//                        } else {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: translations.printdialogue_undefined_report, //'Det er ikke definert en rapport for denne siden.',
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (self) {
//                                        self.close();
//                                    }
//                                }]
//                            });

//                            return;
//                        }
//                        break;
//                    case 'selectreport':
//                        go({
//                            webpage_name: stateService.getCurrentName(),
//                            argtype: 'stockbatch_keyno',
//                            argvalue: vm.model.edit.stockbatch_keyno
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();

//                if (vm.model.edit.stockplace_id > '') retrieveReportDefinitions();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
